export const PROGRAM_TIME_FORMAT = 'dddd D MMMM [à] H[h]mm';
